import { getRenewalReminderCardStatus } from './Api';

let renewalReminderCard;
let renewalReminderCardPromise = null;

export const showRenewalReminderCard = () => renewalReminderCard;

export const setRenewalReminderCardStatus = value => (renewalReminderCard = value);

export const fetchAndCacheRenewalReminderCardStatus = () => {
  if (showRenewalReminderCard()) {
    return Promise.resolve(showRenewalReminderCard());
  }

  // if already made api call
  if (renewalReminderCardPromise !== null) {
    return renewalReminderCardPromise;
  }

  renewalReminderCardPromise = getRenewalReminderCardStatus()
    .then(response => {
      setRenewalReminderCardStatus(response);
      renewalReminderCardPromise = null;
      return response;
    })
    .catch(err => {
      renewalReminderCardPromise = null;
      throw err;
    });

  return renewalReminderCardPromise;
};
